import { type RefObject, useLayoutEffect, useRef } from 'react'

import { Card } from '~/db/types'

import type { Direction } from './types'

export const useScrollToLatest = (
  cards: Card[],
  isFetching: boolean,
  preventScrolling: boolean,
  direction: Direction,
  cardsContainerRef: RefObject<HTMLDivElement | null>,
) => {
  const isInitialScrollToBottom = useRef(true)
  const latestCard = direction === 'asc' ? cards.at(-1) : cards[0]

  useLayoutEffect(() => {
    if (isFetching || preventScrolling) return

    if (!latestCard?.id) return

    const cardsContainer = cardsContainerRef.current

    if (!cardsContainer) return

    cardsContainer.scrollTo({
      top: cardsContainer.scrollHeight,
      behavior: isInitialScrollToBottom.current ? 'instant' : 'smooth',
    })
    isInitialScrollToBottom.current = false
  }, [cardsContainerRef, isFetching, latestCard?.id, preventScrolling])
}
